module.exports = __webpack_public_path__ + "4680be925392884bb9d508b4b664a4dd.pdf";